import * as React from "react";

const HeroBackgroundVector = ({ width = "1382", height = "535" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1382 535"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.2"
        d="M69.1224 285.901L81.9007 263.898L166.779 313.293L153.961 335.265C153.178 336.592 152.023 337.672 150.646 338.357L124.973 351.019C122.622 352.182 119.856 352.09 117.599 350.77L73.6088 325.173C71.3546 323.863 69.9054 321.504 69.7563 318.882L68.0836 290.307C67.9922 288.766 68.3581 287.239 69.1349 285.908L69.1224 285.901ZM94.6597 173.409C89.72 147.871 93.6411 120.497 107.777 96.2007C137.429 45.2453 204.076 23.2749 259.848 55.7327C312.864 86.5828 330.756 154.734 299.791 207.95C285.659 232.24 263.789 249.177 239.148 257.503C223.88 262.659 197.052 276.027 180.315 291.362L157.441 278.047C158.629 276.363 159.996 274.816 161.522 273.426C170.417 265.323 195.038 244.96 230.936 232.837C250.485 226.228 266.978 212.756 277.375 194.892C301.065 154.191 287.338 101.858 246.756 78.2363C207.517 55.3988 154.838 66.7145 130.23 109.264C119.887 127.151 116.214 147.974 120.165 168.368C127.401 205.801 121.78 237.301 119.138 248.906C118.691 250.876 118.025 252.779 117.17 254.605L94.2958 241.291C99.3574 219.157 97.7238 189.233 94.6731 173.401L94.6597 173.409ZM152.406 122.175C168.959 93.736 205.462 84.0339 233.793 100.515C237.516 102.681 238.777 107.468 236.593 111.221C234.409 114.975 229.623 116.237 225.9 114.071C205.012 101.911 178.098 109.075 165.903 130.026C163.719 133.78 158.932 135.041 155.21 132.875C151.487 130.709 150.226 125.923 152.41 122.169L152.406 122.175Z"
        stroke="white"
        strokeWidth="4"
      />
      <g clipPath="url(#clip0_749_1811)">
        <path
          opacity="0.2"
          d="M977.646 69.4768L1097.06 80.8262L1023.48 174.95L906.293 163.72L977.646 69.4768Z"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.2"
          d="M1000.76 122.672L1057.38 127.509L1095.24 214.638"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.2"
          d="M937.085 167.513L955.119 209.015C1023.15 237.785 1069.86 217.117 1095.69 147.932L1077.41 105.853"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        opacity="0.2"
        d="M1376.05 434.87L1354.79 430.019C1353.95 427.632 1352.96 425.275 1351.81 422.949L1364.7 405.903C1366.05 404.109 1365.87 401.585 1364.25 400.004L1345.42 381.514C1343.86 379.978 1341.43 379.796 1339.65 381.088L1321.79 394.074C1321.17 393.8 1320.54 393.526 1319.92 393.283L1317.03 372.923C1316.73 370.718 1314.84 369.076 1312.61 369.076L1286.22 369C1284.04 369 1282.17 370.566 1281.8 372.725L1278.59 391.382C1275.4 392.355 1272.29 393.618 1269.25 395.123L1253.76 385.3C1251.95 384.16 1249.58 384.449 1248.11 386L1229.94 405.128C1228.44 406.709 1228.3 409.157 1229.61 410.906L1240.37 425.229C1239.43 427.343 1238.61 429.487 1237.91 431.677L1220.05 435.691C1217.92 436.177 1216.45 438.124 1216.55 440.298L1217.97 466.649C1218.09 468.793 1219.7 470.542 1221.81 470.846L1239.44 473.339C1240.38 475.696 1241.49 477.992 1242.76 480.258L1232.62 496.467C1231.46 498.307 1231.8 500.724 1233.42 502.184L1253.06 519.822C1254.31 520.947 1256.02 521.251 1257.54 520.719C1258.01 520.552 1258.47 520.309 1258.88 519.974L1274.1 507.673C1275.49 508.22 1276.92 508.722 1278.37 509.163L1281.88 529.295C1282.27 531.545 1284.29 533.142 1286.57 532.99L1312.9 531.317C1313.31 531.287 1313.72 531.211 1314.1 531.074C1315.74 530.496 1316.94 529.006 1317.08 527.212L1318.64 507.871C1320.47 507.171 1322.26 506.396 1324.04 505.514L1339.98 517.1C1341.21 517.997 1342.75 518.18 1344.1 517.709C1344.74 517.481 1345.35 517.1 1345.85 516.583L1364.13 497.561C1365.64 495.995 1365.81 493.562 1364.53 491.814L1352.75 475.696C1353.16 474.799 1353.54 473.887 1353.89 472.974L1374.88 470.116C1375.18 470.07 1375.49 470.009 1375.76 469.903C1377.48 469.295 1378.69 467.683 1378.75 465.813L1379.55 439.431C1379.61 437.287 1378.15 435.402 1376.06 434.931L1376.05 434.87ZM1310.27 471.211C1298.75 478.752 1283.26 475.498 1275.72 463.973C1268.2 452.447 1271.44 436.938 1282.96 429.411C1284.67 428.286 1286.48 427.404 1288.34 426.75C1298.91 423.025 1311.1 426.841 1317.5 436.649C1325.03 448.174 1321.79 463.684 1310.27 471.211V471.211Z"
        stroke="white"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
      <defs>
        <clipPath id="clip0_749_1811">
          <rect
            width="212"
            height="184"
            fill="white"
            transform="translate(880.547 109.488) rotate(-23.4863)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HeroBackgroundVector;
